import React, { useEffect, useRef, useState } from "react";

const STATUTS_ACHAT = [
  "Non Réglé",
  "Réglé",
  "En Attente",
  "Annulé",
  "Remboursé",
  "Partiellement Réglé",
];

const FiltersToolbar = ({
  articles,
  seasons,
  filterNom,
  setFilterNom,
  filterArticle,
  setFilterArticle,
  filterStatutReglementList,
  setFilterStatutReglementList,
  filterTypeReglement,
  setFilterTypeReglement,
  selectedSeason,
  setSelectedSeason,
}) => {
  // Dropdown multi-statuts
  const [isStatusOpen, setIsStatusOpen] = useState(false);
  const statusRef = useRef(null);

  // Fermer au clic extérieur
  useEffect(() => {
    const onClickOutside = (e) => {
      if (!statusRef.current) return;
      if (!statusRef.current.contains(e.target)) setIsStatusOpen(false);
    };
    document.addEventListener("mousedown", onClickOutside);
    return () => document.removeEventListener("mousedown", onClickOutside);
  }, []);

  // Helpers
  const toggleStatut = (s) => {
    setFilterStatutReglementList((prev) =>
      prev.includes(s) ? prev.filter((x) => x !== s) : [...prev, s]
    );
  };

  const selectAll = () => setFilterStatutReglementList([...STATUTS_ACHAT]);
  const clearAll = () => setFilterStatutReglementList([]);

  const statutButtonLabel =
    filterStatutReglementList.length === 0
      ? "Statut (tous)"
      : `Statut (${filterStatutReglementList.length})`;

  return (
    <div className="px-5 pt-5 pb-4 sm:px-8">
      <div className="grid grid-cols-1 md:grid-cols-5 gap-3">
        {/* Nom / utilisateur / adhérent / email */}
        <input
          type="text"
          placeholder="Filtrer par nom (utilisateur/adhérent) ou email…"
          className="rounded-xl border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-900 dark:text-slate-100 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-violet-400"
          value={filterNom}
          onChange={(e) => setFilterNom(e.target.value)}
        />

        {/* Article */}
        <select
          className="rounded-xl border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-900 dark:text-slate-100 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-violet-400"
          value={filterArticle}
          onChange={(e) => setFilterArticle(e.target.value)}
        >
          <option value="">Article (tous)</option>
          <option value="Règlement Inscription">Règlement Inscription</option>
          {articles.map((a) => (
            <option key={a.id} value={a.nom}>
              {a.nom}
            </option>
          ))}
        </select>

        {/* Statut d'achat — multi-choix */}
        <div className="relative" ref={statusRef}>
          <button
            type="button"
            onClick={() => setIsStatusOpen((v) => !v)}
            className="w-full rounded-xl border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-900 dark:text-slate-100 px-3 py-2 text-left focus:outline-none focus:ring-2 focus:ring-violet-400"
            title="Filtrer sur plusieurs statuts"
          >
            {statutButtonLabel}
          </button>

          {isStatusOpen && (
            <div className="absolute z-50 mt-2 w-72 rounded-xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 shadow-xl p-3">
              <div className="mb-2 flex items-center justify-between gap-2">
                <button
                  type="button"
                  onClick={selectAll}
                  className="text-xs px-2 py-1 rounded-md ring-1 ring-slate-300 dark:ring-slate-700 hover:bg-slate-50 dark:hover:bg-slate-800"
                >
                  Tout
                </button>
                <button
                  type="button"
                  onClick={clearAll}
                  className="text-xs px-2 py-1 rounded-md ring-1 ring-slate-300 dark:ring-slate-700 hover:bg-slate-50 dark:hover:bg-slate-800"
                >
                  Effacer
                </button>
              </div>

              <ul className="max-h-60 overflow-auto space-y-1 pr-1">
                {STATUTS_ACHAT.map((s) => {
                  const id = `achat-status-${s
                    .replace(/\s+/g, "-")
                    .toLowerCase()}`;
                  const checked = filterStatutReglementList.includes(s);
                  return (
                    <li key={s} className="flex items-center gap-2">
                      <input
                        id={id}
                        type="checkbox"
                        checked={checked}
                        onChange={() => toggleStatut(s)}
                        className="h-4 w-4 rounded border-slate-300 dark:border-slate-700"
                      />
                      <label
                        htmlFor={id}
                        className="text-sm select-none text-slate-800 dark:text-slate-200"
                      >
                        {s}
                      </label>
                    </li>
                  );
                })}
              </ul>
            </div>
          )}
        </div>

        {/* Type */}
        <select
          className="rounded-xl border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-900 dark:text-slate-100 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-violet-400"
          value={filterTypeReglement}
          onChange={(e) => setFilterTypeReglement(e.target.value)}
        >
          <option value="">Type (tous)</option>
          <option value="En ligne">En ligne</option>
          <option value="Chèque">Chèque</option>
          <option value="Espèces">Espèces</option>
          <option value="Virement">Virement</option>
          <option value="CB">CB</option>
          <option value="Autre">Autre</option>
        </select>

        {/* Saison */}
        <select
          className="rounded-xl border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-900 dark:text-slate-100 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-violet-400"
          value={selectedSeason}
          onChange={(e) => setSelectedSeason(e.target.value)}
        >
          {seasons.map((season) => (
            <option key={season} value={season}>
              {season}
            </option>
          ))}
          {!selectedSeason && !seasons.length && (
            <option value="">Aucune saison</option>
          )}
        </select>
      </div>

      {/* Chips (optionnel) — affiche les statuts sélectionnés */}
      {filterStatutReglementList.length > 0 && (
        <div className="mt-2 flex flex-wrap gap-2 text-xs">
          {filterStatutReglementList.map((s) => (
            <span
              key={s}
              className="inline-flex items-center gap-1 rounded-md px-2 py-1 ring-1 ring-slate-300 dark:ring-slate-700 bg-white/70 dark:bg-slate-900/60 text-slate-700 dark:text-slate-200"
            >
              {s}
              <button
                type="button"
                onClick={() =>
                  setFilterStatutReglementList((prev) =>
                    prev.filter((x) => x !== s)
                  )
                }
                className="ml-1 opacity-70 hover:opacity-100"
                aria-label={`Retirer ${s}`}
                title={`Retirer ${s}`}
              >
                ✕
              </button>
            </span>
          ))}
          <button
            type="button"
            onClick={() => setFilterStatutReglementList([])}
            className="text-xs underline decoration-dotted hover:opacity-80"
          >
            Effacer tout
          </button>
        </div>
      )}
    </div>
  );
};

export default FiltersToolbar;
